import gql from 'graphql-tag';
import { graphql } from '../../utils/fetch';

const MAX_UNDO_STACK_SIZE = 10;
const LIST_KEY = 'shopping_list_id';

const state = {
  // Map of items by id for shopping list items to resolve
  // associated foodItem names
  foodItems: {},

  undoStack: [],
  redoStack: [],

  defaultShoppingListId: localStorage.getItem(LIST_KEY),
  currentShoppingList: null,
};

const getters = {
  defaultShoppingListId: s => s.defaultShoppingListId,
  currentShoppingList: s => s.currentShoppingList,

  foodItemName: s => (id) => {
    if (!id || !s.foodItems) {
      return '';
    }

    const item = s.foodItems[id];
    if (item && item.name) {
      return item.name;
    }

    return '';
  },
};

const mutations = {
  pushUndo(s, { undoAction, isRedoAction }) {
    s.undoStack.push(undoAction);
    if (s.undoStack.length > MAX_UNDO_STACK_SIZE) {
      s.undoStack.shift();
    }

    if (!isRedoAction) {
      s.redoStack = [];
    }
  },

  pushRedo(s, undoAction) {
    s.redoStack.push(undoAction);
  },

  updateUndoRedoItem(s, { oldItem, newItem }) {
    const updateItemFunc = (action) => {
      if (typeof action.updateItem === 'function') {
        action.updateItem(oldItem, newItem);
      }
    };

    s.undoStack.forEach(updateItemFunc);
    s.redoStack.forEach(updateItemFunc);
  },

  clearUndoRedo(s) {
    s.undoStack = [];
    s.redoStack = [];
  },

  defaultShoppingListId(s, id) {
    s.defaultShoppingListId = id;
    localStorage.setItem(LIST_KEY, id);
  },

  currentShoppingList(s, shoppingList) {
    s.currentShoppingList = shoppingList;
  },
};

const actions = {
  popUndo(context) {
    if (context.state.undoStack.length === 0) {
      return Promise.reject({ message: 'Nothing to undo' });
    }

    const itemAction = context.state.undoStack.pop();
    return Promise.resolve(itemAction);
  },

  popRedo(context) {
    if (context.state.redoStack.length === 0) {
      return Promise.reject({ message: 'Nothing to redo' });
    }

    const itemAction = context.state.redoStack.pop();
    return Promise.resolve(itemAction);
  },

  fetchFoodItems(context, ids) {
    return graphql.query({
      query: gql`query FoodITems($ids: [ID!]!) {
        foodItems(ids: $ids) {
          id
          name
        }
      }`,
      variables: {
        ids,
      },
    }).then(({ data: { foodItems } }) => {
      const foodItemsMap = {};
      foodItems.forEach((foodItem) => {
        foodItemsMap[foodItem.id] = foodItem;
      });

      context.state.foodItems = foodItemsMap;
      return foodItemsMap;
    });
  },
};

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/shoppingList.js